module.exports = __webpack_public_path__ + "static/media/34DSS4.a7b6c708.jpg";